import { render, staticRenderFns } from "./orderDataStatistics.vue?vue&type=template&id=78668036&scoped=true"
import script from "./orderDataStatistics.vue?vue&type=script&lang=js"
export * from "./orderDataStatistics.vue?vue&type=script&lang=js"
import style0 from "./orderDataStatistics.vue?vue&type=style&index=0&id=78668036&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78668036",
  null
  
)

export default component.exports